import { styled } from '@mui/material'

export const RequirementsList = styled('ul')`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin: ${({ theme }) => theme.spacing(1, 0, 0)};
  padding: 0;
  list-style: none;
`

export const RequirementItem = styled('li')`
  display: flex;
  align-items: center;
  gap: 8px;
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: 14px;
  line-height: 20px;

  & .MuiSvgIcon-root,
  & .MuiCircularProgress-root {
    flex-shrink: 0;
  }
`
